export const serializeSchema = (...schemas: Record<string, unknown>[]): string => {
		const combinedSchema = {
				'@context': 'https://schema.org',
				'@graph': schemas,
		};
		return `<script type="application/ld+json">${JSON.stringify(combinedSchema)}</script>`;
};